import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "utils";
import Device from "@/utils/device";
import Image from "next/image";

const images = [
  {
    gridArea: "One",
    image: "/images/old-sessions-house/dining-table.jpg",
  },
  {
    gridArea: "Two",
    image: "/images/old-sessions-house/ceiling.jpg",
  },
  {
    gridArea: "Three",
    image: "/images/old-sessions-house/sun-loungers.jpg",
  },
  {
    gridArea: "Four",
    image: "/images/old-sessions-house/exterior.jpg",
  },
  {
    gridArea: "Five",
    image: "/images/old-sessions-house/tables.jpg",
  },
  {
    gridArea: "Six",
    image: "/images/old-sessions-house/empty-room.jpg",
  },
];

type StyleProps = {
  gridArea?: string;
};

const ImagesContent: FunctionComponent = () => {
  return (
    <S.Section data-cy="SF-content-2023">
      <S.GridContainer>
        {images.map((image) => (
          <>
            <S.ImageContainer gridArea={image.gridArea}>
              <Image src={image.image} alt="" layout="fill" objectFit="cover" />
            </S.ImageContainer>
          </>
        ))}
      </S.GridContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  padding: 10% 10% 15% 10%;
  background: ${colours.shell};
  display: flex;
  flex-direction: column;

  @media ${Device.tablet} {
    padding: 0% 10% 2% 10%;
  }
`;

S.GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(6, 1fr);
  grid-template-areas:
    "One One"
    "Five Five"
    "Two Two"
    "Two Two"
    "Three Four"
    "Six Six";
  grid-gap: 10px;

  @media ${Device.tablet} {
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: 1fr 1fr 1.5fr 1fr 1fr;
    grid-template-areas:
      "One One Two Three Four"
      "Five Five Two Six Six";
    grid-gap: 20px;
  }
`;

S.ImageContainer = styled.div<StyleProps>`
  grid-area: ${(p) => p.gridArea};
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  aspect-ratio: 2/1;

  @supports not (aspect-ratio: 2/1) {
    &::before {
      float: left;
      padding-top: 50%;
      content: "";
    }
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }

  @media (min-width: ${Device.desktop}) {
    aspect-ratio: 1/1.2;

    @supports not (aspect-ratio: 1/1.2) {
      &::before {
        float: left;
        padding-top: 120%;
        content: "";
      }
      &::after {
        display: block;
        content: "";
        clear: both;
      }
    }
  }
`;

export default ImagesContent;
